var _class;
import { observer } from "mobx-react";
import { Component } from "react";
import { withTranslation } from "react-i18next";
import styled from "styled-components";
import { applyTranslationIfExists } from "../../../../Language/languageHelpers";
import Box from "../../../../Styled/Box";
import Icon, { GLYPHS } from "../../../../Styled/Icon";
import MapIconButton from "../../../MapIconButton/MapIconButton";
import { jsx as _jsx } from "react/jsx-runtime";
let MapNavigationItemBase = observer(_class = class MapNavigationItemBase extends Component {
  render() {
    const {
      closeTool = true,
      item,
      expandInPlace,
      i18n
    } = this.props;
    if (item.render) return /*#__PURE__*/_jsx(Control, {
      ref: item.controller.itemRef,
      children: item.render
    }, item.id);
    return /*#__PURE__*/_jsx(Control, {
      ref: item.controller.itemRef,
      children: /*#__PURE__*/_jsx(MapIconButton, {
        expandInPlace: expandInPlace === undefined ? true : expandInPlace,
        noExpand: item.noExpand,
        iconElement: () => /*#__PURE__*/_jsx(Icon, {
          glyph: item.controller.glyph
        }),
        title: applyTranslationIfExists(item.title || item.name, i18n),
        onClick: () => {
          item.controller.handleClick();
        },
        disabled: item.controller.disabled,
        primary: item.controller.active,
        closeIconElement: closeTool ? () => /*#__PURE__*/_jsx(Icon, {
          glyph: GLYPHS.closeTool
        }) : undefined,
        children: applyTranslationIfExists(item.name, i18n)
      })
    });
  }
}) || _class;
export const Control = styled(Box).attrs({
  centered: true,
  column: true
}).withConfig({
  displayName: "MapNavigationItem__Control",
  componentId: "sc-1ybl40e-0"
})(["pointer-events:auto;@media (min-width:", "px){margin:0;padding-top:10px;height:auto;}@media (max-width:", "px){padding-right:10px;margin-bottom:5px;}text-align:center;"], props => props.theme.sm, props => props.theme.mobile);
export const MapNavigationItem = withTranslation()(MapNavigationItemBase);